import { TestableComponent } from 'common/interfaces';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';

interface Props extends TestableComponent {
  id: string;
  title: string | React.ReactNode;
  subtitle?: string;
  disabled?: boolean;
}

function InnerSettingsMenuItem({ id, title, subtitle, disabled, testId }: Props) {
  const disabledClass = useMemo(() => {
    return disabled && 'disabled';
  }, [disabled]);

  const hasSubtitleClass = useMemo(() => (!isEmpty(subtitle) ? 'has-subtitle' : ''), [subtitle]);

  return (
    <div
      className={`inner-settings-menu-item ${disabledClass} ${hasSubtitleClass}`}
      key={id}
      data-test-id={testId}
      data-disabled={disabled || false}
    >
      <div className="inner-settings-menu-title" data-test-id={`${testId}-title`}>
        {/* inner menu title */}
        {title}
      </div>
      {/* inner menu subtitle */}
      {!isEmpty(subtitle) && (
        <div className="inner-settings-menu-subtitle" data-test-id={`${testId}-subtitle`}>
          {subtitle}
        </div>
      )}
    </div>
  );
}

export default React.memo(InnerSettingsMenuItem);
